import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import api from '../services/api';
import './SolicitudesFotografos.css';

const SolicitudesFotografos = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  const cargarDatos = async () => {
    try {
      setCargando(true);
      const res = await api.get('/fotografos/solicitudes');
      setSolicitudes(res.data);
    } catch (e) {
      setError('Error al cargar las solicitudes');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargarDatos(); }, []);

  const toggleContactado = async (solicitud) => {
    try {
      await api.put(`/fotografos/solicitudes/${solicitud.id}/contactado`, {
        contactado: !solicitud.contactado
      });
      await cargarDatos();
    } catch (e) {
      alert('No se pudo actualizar la solicitud');
    }
  };

  const waLink = (telefono) => {
    const limpio = (telefono || '').replace(/\D/g, '');
    return `https://wa.me/521${limpio}`;
  };

  if (cargando) return <LoadingSpinner mensaje="Cargando solicitudes..." />;
  if (error) return <div className="unete-error">{error}</div>;

  return (
    <div className="solicitudes-fotografos">
      <h1>📸 Solicitudes de Fotógrafos</h1>
      <p className="solicitudes-resumen">
        {solicitudes.length} solicitud(es) · {solicitudes.filter(s => !s.contactado).length} sin contactar
      </p>

      {solicitudes.length === 0 && (
        <p className="solicitudes-sin-datos">Aún no hay solicitudes registradas.</p>
      )}

      {solicitudes.map((s) => (
        <div key={s.id} className={`solicitud-card ${s.contactado ? 'contactado' : ''}`}>
          <div className="solicitud-header">
            <span className="solicitud-nombre">{s.nombre}</span>
            <span className="solicitud-fecha">{new Date(s.fechaCreacion).toLocaleString('es-MX')}</span>
          </div>
          <div className="solicitud-datos">
            <span>📞 <a href={waLink(s.telefono)} target="_blank" rel="noopener noreferrer">{s.telefono}</a></span>
            {s.ciudad && <span>📍 {s.ciudad}</span>}
            {s.equipoFotografico && <span>📷 {s.equipoFotografico}</span>}
            {s.experiencia && <span>📝 {s.experiencia}</span>}
          </div>
          <div className="solicitud-acciones">
            <button
              className={s.contactado ? 'marcado' : ''}
              onClick={() => toggleContactado(s)}
            >
              {s.contactado ? '✓ Contactado' : 'Marcar como contactado'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SolicitudesFotografos;
